import * as React from 'react';
var WizardContext = React.createContext({
  goToStepById: function goToStepById() {
    return null;
  },
  goToStepByName: function goToStepByName() {
    return null;
  },
  onNext: function onNext() {
    return null;
  },
  onBack: function onBack() {
    return null;
  },
  onClose: function onClose() {
    return null;
  },
  activeStep: {
    name: null
  }
});
export var WizardContextProvider = WizardContext.Provider;
export var WizardContextConsumer = WizardContext.Consumer;